import dayjs from 'dayjs';

export function formatDateTime(value, format = 'DD-MM-YYYY HH:mm') {
  if (!value) return '-';

  const parsed = dayjs(value);
  if (!parsed.isValid()) return '-';

  return parsed.format(format);
}
